import { render, staticRenderFns } from "./ModalOrderCertified.vue?vue&type=template&id=7cf0b919&"
import script from "./ModalOrderCertified.vue?vue&type=script&lang=js&"
export * from "./ModalOrderCertified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports